export const validations: any = [{
  key: 'pies64',
  title: 'PIES 6.4',
  name: 'PIES_6_4',
}, {
  key: 'pies65',
  title: 'PIES 6.5',
  name: 'PIES_6_5',
}, {
  key: 'pies67',
  title: 'PIES 6.7',
  name: 'PIES_6_7',
}, {
  key: 'profileValidation',
  title: 'Profile validation',
  name: 'PROFILE_VALIDATION',
}, {
  key: 'aces30',
  title: 'ACES 3.0',
  name: 'ACES_3_0',
}, {
  key: 'aces32',
  title: 'ACES 3.2',
  name: 'ACES_3_2',
}];
